import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Table,
  Form,
  Modal,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  TabPane,
  TabContent,
  NavItem,
  Nav,
  NavLink,
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import Pagi2 from "common/utils/Pagi2";
import { CommonTableContainer } from "common/utils/ComonTableContainer";

import "../../common/styles/customer.css";
import Swal from "sweetalert2";
import classnames from "classnames";
import ViewContacts from "./ViewContacts";
import ViewProfile from "./ViewProfile";
import ViewNotes from "./ViewNotes";
import ViewProposal from "./ViewProposal";
import ViewContracts from "./ViewContracts";
import ViewProject from "./ViewProject";
import ViewTask from "./ViewTask";
import ViewSupport from "./ViewSupport";
import ViewFiles from "./ViewFiles";
import axios from "axios";
import AccessDeniedPopup from "components/Common/AccessDeniedPopup";
import Loader from "components/Common/Loader";
import configure from "configure";
import secureLocalStorage from "react-secure-storage";
import SearchFilter from "components/Common/SearchFilter";
import Pagination from "common/utils/Pagination";
import { customGlobalFilter } from "utils/common-helpers";

const CustomerIndex = () => {
  document.title = "Customer | Zithas Technologies";

  const [fixedContent, setFixedContent] = useState(false);
  const [modal_fullscreen, setmodal_fullscreen] = useState(false);
  const [verticalActiveTab, setverticalActiveTab] = useState("1");
  const [modal_Access, setAccessDenied] = useState(false);
  const [loading, setLoading] = useState(false);
  const [auth_id, setAuth_id] = useState(null);

  const [data, setData] = useState([]);

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      setmodal_fullscreen(false);
    }
  });

  useEffect(() => {
    const authUser = secureLocalStorage.getItem("User");
    setAuth_id(authUser.id);
    getCustmerData();
  }, [auth_id]); // Should not pass auth_id as dependance

  //  Fetch Customer Data
  const getCustmerData = async () => {
    setLoading(true);
    try {
      const authUser = secureLocalStorage.getItem("Token");
      const resp = await axios({
        method: "get",
        url: `${configure.apiUrl}/customers`,
        headers: {
          Authorization: `Bearer ${authUser}`,
        },
      }).then((res) => {
        setData(res.data.customers);
        setLoading(false);
      });
    } catch (error) {
      console.log("Customer Data Error", error);
      setLoading(false);
    }
  };

  const toggleVertical = (tab) => {
    if (verticalActiveTab !== tab) {
      setverticalActiveTab(tab);
    }
  };

  const [fixedSideTab, setFixedSideTab] = useState(false);

  document.addEventListener("scroll", () => {
    if (window.scrollY > 68) {
      setFixedSideTab(true);
    } else {
      setFixedSideTab(false);
    }
  });

  const navigate = useNavigate();

  document.addEventListener("scroll", () => {
    if (window.scrollY > 165) {
      setFixedContent(true);
    } else {
      setFixedContent(false);
    }
  });

  const [customer, setCustomer] = useState([]);
  const [customer_contact, setCustomerContact] = useState([]);
  const [customer_notes, setCustomerNotes] = useState([]);
  const [customer_proposal, setCustomerProposal] = useState([]);
  const [customer_contract, setCustomerContract] = useState([]);
  const [customer_project, setCustomerProject] = useState([]);
  const [customer_task, setCustomerTask] = useState([]);
  const [customer_support, setCustomerSupport] = useState([]);
  const [customer_files, setCustomerFiles] = useState([]);

  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        isInfoIcon: false,
        isShortIcon: true,
        className: "customer_id",
        Cell: (cellProps) => {
          return <div className="text-center">{cellProps.row.original.id}</div>;
        },
      },

      {
        Header: "Company",
        accessor: "company",
        isInfoIcon: false,
        isShortIcon: true,
        className: "customer_company",
      },

      {
        Header: "Primary Contact",
        accessor: "contacts",
        isInfoIcon: false,
        isShortIcon: true,
        className: "primary_contact",
        Cell: cellProps => {
          // console.log(cellProps.row.original)
          const data = cellProps.row.original?.contacts?.filter((obj) => obj?.trash != 1)?.filter(
            obj => obj.primarycontact == "on"
          )
          return <div>{data[0]?.name || "-"}</div>
        },
      },

      {
        Header: "Primary Email",
        accessor: "email",
        isInfoIcon: false,
        isShortIcon: true,
        className: "email",
        Cell: cellProps => {
          const data = cellProps.row.original?.contacts?.filter((obj) => obj?.trash != 1)?.filter(
            obj => obj.primarycontact == "on"
          )
          return <div>{data[0]?.email || cellProps.row.original?.email}</div>
        },
      },
      {
        Header: "Phone",
        accessor: "phone",
        isInfoIcon: false,
        isShortIcon: true,
        className: "customer_phone",
        Cell: (cellProps) => {
          console.log(cellProps.row.original?.contacts)
          const data = cellProps.row.original?.contacts?.filter((obj) => obj?.trash != 1)?.filter(
            obj => obj.primarycontact == "on"
          )
          return (
            <div className="text-start">
              {data[0]?.phone || cellProps.row.original?.phone}
            </div>
          );
        },
      },

      {
        Header: "Action",
        accessor: "action",
        className: "customer_action",
        isInfoIcon: false,
        Cell: (cellProps) => {
          const viewData = async (e) => {
            setCustomer([cellProps.row.original]);
            setmodal_fullscreen(true);
            setLoading(true);
            const token = secureLocalStorage.getItem("Token");
            try {
              const res = await axios
                .post(
                  `${configure.apiUrl}/customers/data`,
                  {
                    customer_id: cellProps.row.original.id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  }
                )
                .then((res) => {
                  setCustomer(res.data?.customer);
                  setCustomerContact(res.data?.contacts);
                  setCustomerNotes(res.data?.notes);
                  setCustomerProposal(res.data?.proposals);
                  setCustomerContract(res.data?.contracts);
                  setCustomerProject(res.data?.projects);
                  setCustomerTask(res.data?.task);
                  setCustomerSupport(res.data?.support);
                  setCustomerFiles(res.data.files);
                  setLoading(false);
                });
            } catch (error) {
              console.log("Customer - Profile", error);
              setLoading(false);
            }
          };

          return (
            <>
              <div className="d-flex justify-content-center">
                <a
                  onClick={() => viewData()}
                  className="btn btn-sm btn-outline-secondary me-1"
                  title="View Customer"
                >
                  <i className="fas fa-eye "></i>
                </a>
              </div>
            </>
          );
        },
      },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      globalFilter: customGlobalFilter,
      initialState: {
        pageIndex: 0,
        sortBy: [{ id: "id", desc: true }],
      },
    },
    useGlobalFilter,
    usePagination
  )

  const { pageIndex, pageSize, globalFilter } = state;
  useEffect(() => setPageSize(50), []);

  return (
    <React.Fragment>
      {loading && <Loader />}
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={"Dashboard"} breadcrumbItem={"Customer"} />
          <Row>
            <Col lg={12} className="p-0">
              <Card>
                <CardBody>
                  <div className="responsive-table">
                    <div>
                      {/* fixed buttons */}
                      <div
                        className={`flex-column fixed-buttons pt-2 ${fixedContent ? "d-flex" : "d-none"
                          }`}
                      >
                        {/* <Link
                         to="/add_lead" 
                         className=" btn ms-md-2 btn-save btn-label">
                            <i className="fas fa-plus me-1 label-icon"></i> Customer
                        </Link>     */}
                        <button
                          onClick={() => navigate(-1)}
                          className="btn btn-red  fix-btn btn-label"
                        >
                          <i className="dripicons-cross me-2 icon-center label-icon"></i>
                          <span>Cancel</span>
                        </button>
                      </div>
                      <Row className="mb-2">
                        <Col className="col-2">
                          <select
                            className=" me-4 form-select"
                            style={{ width: "100px" }}
                            value={pageSize}
                            onChange={(e) => setPageSize(e.target.value)}
                          >
                            {[10, 25, 50, 100].map((pageSize) => (
                              <option key={pageSize} value={pageSize}>
                                Show {pageSize}
                              </option>
                            ))}
                          </select>
                        </Col>
                        <Col className="col-10 d-flex justify-content-end">
                          <div className="me-2">
                            <div className="search-box me-xxl-2 my-xxl-0 d-inline-block">
                              <div className="position-relative">
                                <label
                                  htmlFor="search-bar-0"
                                  className="search-label"
                                >
                                  <span
                                    id="search-bar-0-label"
                                    className="sr-only"
                                  >
                                    Search this table
                                  </span>
                                  <input
                                    onChange={(e) =>
                                      setGlobalFilter(e.target.value)
                                    }
                                    id="search-bar-0"
                                    type="text"
                                    className=" form-control rounded h-100"
                                    placeholder={`Search...`}
                                    value={globalFilter || ""}
                                  />
                                </label>
                                <i className="bx bx-search-alt search-icon"></i>
                              </div>
                            </div>
                            {/* <SearchFilter
                              preGlobalFilteredRows={preGlobalFilteredRows}
                              globalFilter={state.globalFilter}
                              setGlobalFilter={setGlobalFilter}
                            /> */}
                          </div>

                          <div className="text-md-end">
                            {/* <Link
                             to="/add_lead" 
                             className=" btn ms-md-2 btn-save  btn-label me-2">
                                <i className="fas fa-plus me-1 label-icon"></i> Customer
                            </Link>  */}
                            <button
                              onClick={() => navigate(-1)}
                              className=" btn btn-red btn-label"
                            >
                              <i className="dripicons-cross me-2  lab label-icon"></i>
                              CANCEL
                            </button>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <div className="col-12">
                          <div className="position-relative shadow">
                            <table
                              className="table table-bordered mt-4"
                              {...getTableProps()}
                            >
                              <thead
                                className={`${fixedContent ? "fix-header" : ""
                                  } fix-lead-header`}
                              >
                                {headerGroups.map((headerGroup, i) => (
                                  <tr
                                    key={i}
                                    {...headerGroup.getHeaderGroupProps()}
                                  >
                                    {headerGroup.headers.map((column, index) => (
                                      <th
                                        key={index}
                                        className={`t-col-${index + 1} ${column.className
                                          }`}
                                        {...column.getHeaderProps()}
                                      >
                                        {column.render("Header")}
                                      </th>
                                    ))}
                                  </tr>
                                ))}
                              </thead>

                              <tbody
                                className="fix-lead-header"
                                {...getTableBodyProps()}
                              >
                                {page.map((row, i) => {
                                  prepareRow(row)
                                  let backColor
                                  if (row.original.lead_type == "Hot") {
                                    backColor = "bd-hot"
                                  }
                                  return (
                                    <tr
                                      className={`row-hover ${backColor}`}
                                      {...row.getRowProps()}
                                      key={i}
                                    >
                                      {row.cells.map((cell, index) => {
                                        return (
                                          <td
                                            key={index}

                                            className={`t-col-${index + 1} ${cell.column.className
                                              }`}
                                            {...cell.getCellProps()}
                                          >
                                            {cell.render("Cell")}
                                          </td>
                                        )
                                      })}
                                    </tr>
                                  )
                                })}
                                {page.length == 0 ? (
                                  <tr>
                                    <td className="text-center" colSpan={10}>
                                      No Leads Available
                                    </td>
                                  </tr>
                                ) : null}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Row>

                      {/* Pagination */}
                      <Row className="justify-content-md-end justify-content-center align-items-center">
                        <Pagination
                          gotoPage={gotoPage}
                          previousPage={previousPage}
                          canPreviousPage={canPreviousPage}
                          nextPage={nextPage}
                          canNextPage={canNextPage}
                          pageIndex={pageIndex}
                          pageOptions={pageOptions}
                        />
                      </Row>

                      {/* View Customer */}
                      <Modal
                        size="xl"
                        isOpen={modal_fullscreen}
                        className="modal-fullscreen"
                      >
                        <div className="modal-header mb-0">
                          <div
                            className="d-flex align-items-center justify-content-between"
                            style={{ width: "100%" }}
                          >
                            <h5 className="col-6 modal-title mt-0">
                              Customer Details
                            </h5>
                          </div>

                          <button
                            type="button"
                            onClick={() => {
                              setmodal_fullscreen(false);
                            }}
                            className="ms-4"
                            style={{
                              border: "none",
                              backgroundColor: "transparent",
                            }}
                          >
                            <span
                              aria-hidden="true"
                              style={{
                                color: "#bf1e30",
                                fontSize: "28px",
                                lineHeight: "1px",
                              }}
                            >
                              {" "}
                              &times;{" "}
                            </span>
                          </button>
                        </div>

                        <div className="modal-body hide-bottom-scrollbar ps-3 pe-0 pt-0">
                          <Row className="gx-4 justify-content-between">
                            <Col md="2" className="px-0">
                              <Nav
                                pills
                                className={`side-tab flex-column px-2 py-3 bg-white  ${fixedSideTab ? "fixed-side-tab" : ""
                                  } h-100`}
                              >
                                <NavItem>
                                  <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classnames({
                                      "mb-2": true,
                                      active: verticalActiveTab === "1",
                                    })}
                                    onClick={() => {
                                      toggleVertical("1");
                                    }}
                                  >
                                    Profile
                                  </NavLink>
                                </NavItem>

                                <NavItem>
                                  <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classnames({
                                      "mb-2": true,
                                      active: verticalActiveTab === "2",
                                    })}
                                    onClick={() => {
                                      toggleVertical("2");
                                    }}
                                  >
                                    Contacts
                                  </NavLink>
                                </NavItem>
                                <NavItem>
                                  <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classnames({
                                      "mb-2": true,
                                      active: verticalActiveTab === "3",
                                    })}
                                    onClick={() => {
                                      toggleVertical("3");
                                    }}
                                  >
                                    Notes
                                  </NavLink>
                                </NavItem>
                                <NavItem>
                                  <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classnames({
                                      "mb-2": true,
                                      active: verticalActiveTab === "4",
                                    })}
                                    onClick={() => {
                                      toggleVertical("4");
                                    }}
                                  >
                                    Proposal
                                  </NavLink>
                                </NavItem>
                                <NavItem>
                                  <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classnames({
                                      "mb-2": true,
                                      active: verticalActiveTab === "5",
                                    })}
                                    onClick={() => {
                                      toggleVertical("5");
                                    }}
                                  >
                                    Contract
                                  </NavLink>
                                </NavItem>
                                <NavItem>
                                  <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classnames({
                                      "mb-2": true,
                                      active: verticalActiveTab === "6",
                                    })}
                                    onClick={() => {
                                      toggleVertical("6");
                                    }}
                                  >
                                    Project
                                  </NavLink>
                                </NavItem>
                                {/* <NavItem>
                                  <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classnames({
                                      "mb-2": true,
                                      active: verticalActiveTab === "7",
                                    })}
                                    onClick={() => {
                                      toggleVertical("7");
                                    }}
                                  >
                                    General Task
                                  </NavLink>
                                </NavItem> */}
                                {/* <NavItem>
                                  <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classnames({
                                      "mb-2": true,
                                      active: verticalActiveTab === "8",
                                    })}
                                    onClick={() => {
                                      toggleVertical("8");
                                    }}
                                  >
                                    Support
                                  </NavLink>
                                </NavItem> */}
                                {/* <NavItem>
                                  <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classnames({
                                      "mb-2": true,
                                      active: verticalActiveTab === "9",
                                    })}
                                    onClick={() => {
                                      toggleVertical("9");
                                    }}
                                  >
                                    Files
                                  </NavLink>
                                </NavItem> */}
                              </Nav>
                            </Col>
                            <Col md="10" className="bd-right-side-tab">
                              <div className="px-4 h-100 pl-0">
                                <TabContent
                                  activeTab={verticalActiveTab}
                                  className="text-muted mt-4 mt-md-0"
                                >
                                  <TabPane tabId="1">
                                    <ViewProfile customer={customer} />
                                  </TabPane>
                                  <TabPane tabId="2">
                                    <ViewContacts
                                      customer_contact={customer_contact}
                                    />
                                  </TabPane>
                                  <TabPane tabId="3">
                                    <ViewNotes
                                      customer_notes={customer_notes}
                                    />
                                  </TabPane>
                                  <TabPane tabId="4">
                                    <ViewProposal
                                      customer_proposal={customer_proposal}
                                    />
                                  </TabPane>
                                  <TabPane tabId="5">
                                    <ViewContracts
                                      customer_contract={customer_contract}
                                    />
                                  </TabPane>
                                  <TabPane tabId="6">
                                    <ViewProject
                                      customer_project={customer_project || []}
                                    />
                                  </TabPane>
                                  {/* <TabPane tabId="7">
                                    <ViewTask customer_task={customer_task || []} />
                                  </TabPane> */}
                                  <TabPane tabId="8">
                                    <ViewSupport
                                      customer_support={customer_support || []}
                                    />
                                  </TabPane>
                                  <TabPane tabId="9">
                                    <ViewFiles
                                      customer_files={customer_files || []}
                                    />
                                  </TabPane>
                                </TabContent>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </Modal>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <AccessDeniedPopup
        modal_Access={modal_Access}
        setAccessDenied={setAccessDenied}
      />
    </React.Fragment>
  );
};

export default CustomerIndex;
